// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"d3ebe4ff","171":"9fc93506","618":"7d91717e","763":"0706e949"}[chunkId] + ".chunk.js";
};